import { CommanderControlUnitChannelFilterLogicalObject } from '../../pages/AuthenticatedPages/Manager/ManagerPerformances/util/filter.model';
import { mapControlUnitFilterLogicalObjectToAPIFilter } from './util/mapControlUnitFilterLogicalObjectToAPIFilter';
import AxiosFlexeServeInstance from '../shared/AxiosFlexeServe';
import Environment from '../../shared/constants/Environment';
import { toBase64 } from '../../shared/util/base64';
import { AxiosInstance } from 'axios';
import {
  DigitalEventsCommander,
  DigitalEventsControlUnits,
  Sensordata,
  SensordataNewest,
} from './monitoring.model';

export class MonitoringCalls {
  readonly eventServiceURL = Environment.backendAPIEvents;
  readonly sensorDataServiceURL = Environment.backendAPISensors;
  constructor(private axios: AxiosInstance = AxiosFlexeServeInstance) {}

  getSensordataByDeviceID(
    commanderId: string,
    start = 0,
    end = 0,
    commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject
  ) {
    const filter = mapControlUnitFilterLogicalObjectToAPIFilter(
      commanderFilterObject
    );
    if (filter === '{}') return Promise.resolve([]);
    const url = `${this.sensorDataServiceURL}/${toBase64(
      commanderId
    )}?start=${start}&end=${end}&filter=${filter}&onlyValid=true`;
    return this.axios.get<Sensordata[]>(url).then((res) => res.data);
  }

  getEventsByID(
    commanderId: string,
    start = 0,
    end = 0,
    commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject
  ) {
    const filter = mapControlUnitFilterLogicalObjectToAPIFilter(
      commanderFilterObject
    );
    if (filter === '{}') return Promise.resolve([]);
    const url = `${this.eventServiceURL}/${toBase64(
      commanderId
    )}?start=${start}&end=${end}&filter=${filter}&onlyValid=true`;
    return this.axios
      .get<DigitalEventsControlUnits[]>(url)
      .then((res) => res.data);
  }

  getCurrentEventsByID(params: { deviceId: string; commanderId: string }) {
    const { deviceId, commanderId } = params;

    const url = `${this.eventServiceURL}/${toBase64(commanderId)}/newest`;
    return this.axios
      .get<DigitalEventsControlUnits[]>(url)
      .then((res) => ({ deviceId, commanderId, ...res.data }));
  }

  getCurrentSensorDataByID(commanderId: string) {
    const url = `${this.sensorDataServiceURL}/${toBase64(commanderId)}/newest`;
    return this.axios.get<SensordataNewest[]>(url).then((res) => res.data);
  }

  getEventByCommander(
    commanderId: string,
    start = 0,
    end = 0,
    channels: string[]
  ) {
    const url = `${this.eventServiceURL}/${toBase64(
      commanderId
    )}/device?start=${start}&end=${end}&channels=${channels.join(',')}`;
    return this.axios
      .get<DigitalEventsCommander[]>(url)
      .then((res) => res.data);
  }
}
